import {
  DefaultView,
  UpdateOrCreateViewPreferenceInput,
  ViewPreferenceRecognizedLists,
} from '../../../../../../services/modules/userContextPreferences/userContextPreferences.types';
import { CatalogSectionSortCriterionEnum } from '../../../../enums/catalogSectionSortCriterion.enum';
import {
  CatalogViewCatalogFields,
  CatalogViewDraft,
  CatalogViewGroupBy,
  CatalogViewUserField,
} from '../../view/catalogView.types';

export interface ResolvePreferenceWriteParams {
  draft: CatalogViewDraft;
  configSnapshot: CatalogViewCatalogFields;
  dirtyForMe: CatalogViewUserField[];
  hasSavedUserPreference: boolean;
}

interface ResolveDivergentParams {
  draft: CatalogViewDraft;
  configSnapshot: CatalogViewCatalogFields;
}

const resolveDivergentSort = ({
  draft,
  configSnapshot,
}: ResolveDivergentParams): Pick<DefaultView, 'sortCriterion' | 'sortTargetId'> => {
  const hasDivergence =
    draft.sortCriterion !== configSnapshot.sortCriterion ||
    draft.sortTargetId !== configSnapshot.sortTargetId;

  const isTargetMissing =
    draft.sortCriterion === CatalogSectionSortCriterionEnum.CLASSIFICATION_TYPE &&
    draft.sortTargetId === null;

  if (!hasDivergence || isTargetMissing) {
    return {};
  }

  return { sortCriterion: draft.sortCriterion, sortTargetId: draft.sortTargetId };
};

const resolveDivergentGroup = ({
  draft,
  configSnapshot,
}: ResolveDivergentParams): Pick<DefaultView, 'groupBy' | 'groupTargetId'> => {
  const hasDivergence =
    draft.groupBy !== configSnapshot.groupBy ||
    draft.groupTargetId !== configSnapshot.groupTargetId;

  const isTargetMissing =
    draft.groupBy === CatalogViewGroupBy.CLASSIFICATION_TYPE && draft.groupTargetId === null;

  if (!hasDivergence || isTargetMissing) {
    return {};
  }

  return { groupBy: draft.groupBy, groupTargetId: draft.groupTargetId };
};

export const resolvePreferenceWrite = ({
  draft,
  configSnapshot,
  dirtyForMe,
  hasSavedUserPreference,
}: ResolvePreferenceWriteParams): UpdateOrCreateViewPreferenceInput | null => {
  if (draft.isRestorePending && hasSavedUserPreference) {
    return { list: ViewPreferenceRecognizedLists.CATALOG_PRODUCTS, defaultView: null };
  }

  if (dirtyForMe.length === 0) {
    return null;
  }

  return {
    list: ViewPreferenceRecognizedLists.CATALOG_PRODUCTS,
    defaultView: {
      mode: draft.mode,
      cardSize: draft.cardSize,
      ...resolveDivergentSort({ draft, configSnapshot }),
      ...resolveDivergentGroup({ draft, configSnapshot }),
    },
  };
};
